import React, { useState, useMemo } from "react";
import { ChevronsUpDown, Search, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";
import { smartSearch } from "../lib/search";
import { cn } from "../lib/utils";

// Selector con búsqueda: muestra el valor elegido y, al abrir, un campo donde se
// escribe libremente para filtrar las opciones en tiempo real (insensible a acentos).
export const SearchableSelect = ({
  value, onChange, options = [], placeholder = "Selecciona...",
  searchPlaceholder = "Escribe para buscar...", testid, disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const selected = options.find((o) => String(o.value) === String(value));
  const filtered = useMemo(
    () => (q.trim() ? smartSearch(options, q, (o) => [o.label]) : options),
    [q, options]
  );

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setQ(""); }}>
      <PopoverTrigger asChild disabled={disabled}>
        <button type="button" data-testid={testid}
          className="flex h-10 w-full items-center justify-between rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50">
          <span className={cn("truncate text-left", !selected && "text-muted-foreground")}>{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0 ml-2" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 rounded-sm w-[var(--radix-popover-trigger-width)]" align="start">
        <div className="p-2 border-b border-border">
          <div className="relative">
            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={searchPlaceholder}
              className="pl-8 rounded-sm h-9" data-testid={testid ? `${testid}-input` : undefined} />
          </div>
        </div>
        <div className="max-h-64 overflow-y-auto py-1">
          {filtered.length === 0 && <div className="px-3 py-6 text-center text-sm text-muted-foreground">Sin resultados</div>}
          {filtered.map((o) => (
            <button key={o.value} type="button"
              onClick={() => { onChange(o.value); setOpen(false); setQ(""); }}
              className={cn("flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-muted", String(o.value) === String(value) && "bg-primary/10")}
              data-testid={testid ? `${testid}-opt-${o.value}` : undefined}>
              <span className="truncate">{o.label}</span>
              {String(o.value) === String(value) && <Check className="h-4 w-4 text-primary shrink-0 ml-2" />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
